import { Component, inject, Injector, input, ChangeDetectionStrategy } from '@angular/core';
import {
  ResolvableModal,
  RadioOptionComponent,
  MessageBarService,
  translator,
} from '@softline/ui-core';
import { Ticket } from '../../data/ticket.model';
import {
  CancelledError,
  DownloadStore,
  FileService,
  RequestError,
  SOFTLINE_FEATURE_DOWNLOAD,
  Store,
} from '@softline/core';
import {
  SOFTLINE_API_TICKET_EXPORT,
  SOFTLINE_API_TICKET_LIST_EXPORT,
} from '../../ticket.api';
import { handleRequestError } from '@softline/application';
import { CommonModule } from '@angular/common';

import { InterpolatePipe } from '@softline/ui-core';
import { RadioGroupDirective } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { TicketService } from '../../services/ticket.service';
@Component({
  selector: 'soft-export-ticket-dialog',
  imports: [
    CommonModule,
    InterpolatePipe,
    RadioGroupDirective,
    RadioOptionComponent,
    TranslatePipe,
  ],
  templateUrl: './export-ticket-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./export-ticket-dialog.component.css'],
})
export class ExportTicketDialogComponent extends ResolvableModal<any> {
  private store = inject(Store);
  private fileService = inject(FileService);
  private ticketService = inject(TicketService);
  private messageBarService = inject(MessageBarService);
  private injector = inject(Injector);

  private t = translator();

  ticket = input.required<Ticket>();

  isDownloading$ = this.store.observe(
    SOFTLINE_FEATURE_DOWNLOAD,
    DownloadStore.getters.downloading
  );

  async onDownload(id: number | undefined): Promise<void> {
    try {
      if (id) {
        this.messageBarService.info(`loading ticket_${id}.xlsx`);
        const result = await this.store.dispatch(
          SOFTLINE_FEATURE_DOWNLOAD,
          DownloadStore.actions.download,
          {
            location: { path: SOFTLINE_API_TICKET_EXPORT },
            body: { id },
            filename: `ticket_${id}.xlsx`,
          }
        );
        await this.fileService.openBlob(result.content, result.filename);
      } else {
        const ids = this.ticketService.allIds();
        this.messageBarService.info(`loading ticket-list.xlsx`);
        const result = await this.store.dispatch(
          SOFTLINE_FEATURE_DOWNLOAD,
          DownloadStore.actions.download,
          {
            location: { path: SOFTLINE_API_TICKET_LIST_EXPORT },
            body: { ids },
            filename: 'ticket-list.xlsx',
          }
        );
        await this.fileService.openBlob(result.content, result.filename);
      }
      this.resolve(id);
    } catch (e) {
      if (e instanceof CancelledError) {
        this.messageBarService.warning('Der Download wurde abgebrochen');
      } else if (e instanceof RequestError) {
        this.messageBarService.error(this.t('#TICKETS.MESSAGES.GENERAL.ERROR_DOWNLOAD'));
      } else {
        handleRequestError(e, this.injector, { show: true });
      }
    }
  }
}
